<template>
    <v-card class="d-flex align-start mb-2"
            :key="type"
            :color="highlight ? 'grey darken-2' : 'grey darken-3'"
            @mouseover="highlight = true"
            @mouseleave="highlight = false"
            @click="typeSelected(type)">

        <div class="pa-4 align-self-center">
            <v-icon size="30">{{ getIcon(type) }}</v-icon>
        </div>

        <div class="type-box flex-shrink-0 align-self-center">
            {{ ucFirst(type) }}
        </div>

        <div class="align-self-stretch divider" :style="highlight ? 'opacity: 1' : 'opacity: 0.5'">
        </div>

        <div class="pa-2 pl-7 body-2 grey--text text--lighten-1 align-self-center flex-grow-1">
            {{ findDescription(type) }}
        </div>

    </v-card>

</template>

<script>

export default {
    name: "TypeSelectionBox",

    props: {
        type: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            highlight: false,

            typeDescriptions: [
                {
                    type: 'text',
                    description: 'Any content saved to a text -type variable is analysed. Records with partial matches are scored ' +
                        'and returned in the order of highest matching score first.',
                },
                {
                    type: 'keyword',
                    description: 'Keyword variables are always matched with exact search term. Use keyword -variable to ' +
                        'store unstructured categorical data like city or postal code.',
                },
                {
                    type: 'email',
                    description: 'Email variables must contain valid email. ' +
                        'System wide email validation is automatically applied.',
                },
                {
                    type: 'radio',
                    description: 'Radio questions can have single multiple answer option selected.',
                },
                {
                    type: 'checkbox',
                    description: 'Checkbox questions can have multiple answer options selected.',
                },
                {
                    type: 'locale',
                    description: 'Locale question contain standard locale identifier. ' +
                        'System wide validation is automatically applied.',
                },
                {
                    type: 'date',
                    description: 'Use to store dates. Date values can be searched using ranges. System wide validation is automatically applied.',
                },
                {
                    type: 'number',
                    description: 'Use to store numeric data. Numbers can be integers, numbers with decimals ' +
                        'or floating point values',
                },
                {
                    type: 'phone',
                    description: 'Store phone numbers using international e164 -standard. System wide phone number validation is ' +
                        'automatically applied.',
                },
            ]
        }
    },

    methods: {

        typeSelected() {
            this.$emit('select', this.type);
        },

        getIcon(type) {
            return this.$store.state.dataVariableIcons[type];
        },

        findDescription(type) {
            const typeDescription = this.typeDescriptions.find(desc => desc.type === type);

            if (!typeDescription) {
                console.error('Type ' + type + ' not found!');
                return null;
            }

            return typeDescription.description;
        },
    }
}

</script>

<style scoped>

.type-box {
    width: 90px;
}

.divider {
    border-right: 5px solid #2196F3;
}
</style>
